import { Button, Callout, InputGroup, Tab, TabId, Tabs } from '@blueprintjs/core'
import { WorkspaceUserWithAttributes } from 'enablex/sdk'
import { lang, utils } from 'enablex/shared'
// import { CHAT_USER_ROLE } from 'common/defaults'
import _ from 'lodash'
import React, { FC, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import LoadingSection from '~/app/common/LoadingSection'
import { AppState } from '~/app/rootReducer'
import { filterList } from '~/workspace/util'
import style from '../style.scss'
import RoleSection from './RoleSection'
import cx from 'classnames'
import { toggleAnalyticsWindow } from '../reducer'
import { fetchBots } from '~/workspace/bots/reducer'
import ReportingModal from './ReportingModal'

const userFilterFields = ['email', 'attributes.firstname', 'attributes.lastname']

type Props = {
  onPasswordReset: any
  onUserUpdated: () => void
  openModal?: any
} & ConnectedProps<typeof connector>

const UserList: FC<Props> = props => {
  console.log('UserList props', props)
  const [filter, setFilter] = useState('')
  const [isLaptopScreen, setletIsLaptopScreen] = useState(false)
  const [navbarTabId, setNavbarTabId] = useState(props.roles[0]?.id as any)
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })

  useEffect(() => {
    if (!props.bots.length) {
      props.fetchBots()
    }
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      })
      console.log(windowDimensions.width, isLaptopScreen)
    }
    window.addEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    setletIsLaptopScreen(windowDimensions.width <= 1344 ? true : false)
  }, [windowDimensions])

  if (!props.users || props.loading || !props.roles) {
    return <LoadingSection />
  }
  const currentUserEmail = _.get(props.profile, 'email', '').toLowerCase()
  const currentUserisAdminUser = !!_.get(props.profile,'isAdminUser')
  const currentUserisSuperAdmin = !!_.get(props.profile,'isSuperAdmin')
  const currentUserisEnablexAdmin =  !!_.get(props.profile,'isEnablexAdmin')
  const filteredUsers = filterList<WorkspaceUserWithAttributes>(props.users, userFilterFields, filter)
  const roles = props.roles

  const handleNavbarTabChange = (selNavbarTabId: TabId) => {
    setNavbarTabId(selNavbarTabId)
  }

  const branding = utils.getBranding()
  const brandName = branding?.pageTitle || 'EnableX Dialogs'
  return (
    <div className={cx(style.containerLeft, { [style.show]: !isLaptopScreen })}>
      <div className={cx({ [style.forLaptop]: !isLaptopScreen })}>
        <div className={style.container}>
         {(
            <ReportingModal profile= {props.profile} isOpen={props.isAgentAnalyticsOpen} />
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  isAgentAnalyticsOpen: state.collaborators.isAgentAnalyticsOpen,
  profile: state.user.profile,
  roles: state.roles.roles,
  users: state.collaborators.users,
  loading: state.collaborators.loading,
  bots: state.bots.bots
})

const connector = connect(mapStateToProps, { toggleAnalyticsWindow, fetchBots })

export default connector(UserList)
